import { JSConn } from "@/utilities/js-conn";
import LoadingAnimation from "@/components/LoadingAnimation/LoadingAnimation.vue";
import {
  ref,
  onMounted,
  defineComponent,
  computed,
} from "@vue/composition-api";
import { Commodity } from "@/store/modules/commodities";
import { itemRouteBuilder, NamedRts } from "@/router";
import { filter as Rfilter } from "ramda";
import { genericSort, sortIcon } from "@/components/helpers";

export default defineComponent({
  name: "commodities",
  components: {
    LoadingAnimation,
  },

  setup(_props, ctx) {
    let $store = ctx.root.$store;

    let dataLoaded = ref(false);
    let loadingMessage = ref("Loading Commodities...");

    let filter = ref("");

    let sortKey = ref<"name" | "description">("name");
    let sortAsc = ref(true);

    const apiCommodities = computed(() => {
      return $store.getters.commoditiesForTable as Commodity[];
    });

    const localCommodities = ref<Commodity[]>([]);

    const editRouteBuilder = (id: string) => {
      return itemRouteBuilder(NamedRts.commodityEditForm, id);
    };

    const commodities = computed(() => {
      let tmpResults = [...localCommodities.value];

      if (filter.value !== "") {
        let tmpReg = new RegExp(filter.value, "i");
        tmpResults = Rfilter((item: any) => {
          let nameResult = tmpReg.test(item.name);
          let descriptionResult = tmpReg.test(item.description);

          return nameResult || descriptionResult;
        }, tmpResults);
      }

      return tmpResults;
    });

    const localSortIcon = (lSortKey: "name" | "description") => {
      return sortIcon(sortAsc, sortKey, lSortKey);
    };

    const updateSort = (lSortKey: "name" | "description") => {
      localCommodities.value = genericSort(
        [...localCommodities.value],
        sortAsc,
        sortKey,
        lSortKey,
      );
    };

    onMounted(() => {
      const jsConn = new JSConn();
      $store.dispatch("needCommodities", jsConn).then(() => {
        localCommodities.value = [...apiCommodities.value];
        // flip the sort, otherwise on load it would be off
        sortAsc.value = !sortAsc.value;
        updateSort(sortKey.value);
        dataLoaded.value = true;
      });
    });

    return {
      dataLoaded,
      loadingMessage,
      filter,

      commodities,
      editRouteBuilder,

      updateSort,
      localSortIcon,
    };
  },
});
